<h2 mat-dialog-title class="dialog-header">
  {{'workermanager.title' | traduccion}}
  <button mat-icon-button class="close-btn" aria-label="Close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content worker-dialog-content mat-typography">
  <section class="worker-hero">
    <div>
      <div class="worker-kicker">Worker manager</div>
      <h3>#{{ paymentProvider?.id }} · {{ formatEnumLabel(paymentProvider?.type) }}</h3>
      <p>{{ formatEnumLabel(paymentProvider?.status) }} · prioridad {{ valueOrDash(paymentProvider?.priority) }}</p>
    </div>
    <div class="worker-hero-chips">
      <span [class]="statusClass(paymentProvider?.status)">{{ formatEnumLabel(paymentProvider?.status) }}</span>
      <span class="wm-chip wm-chip--neutral">{{ paymentProvider?.periodic ? 'Periódico' : 'Una vez' }}</span>
    </div>
  </section>

  <div class="worker-grid">
    <mat-card class="worker-card">
      <h4>Resumen</h4>
      <div class="worker-fields">
        <div class="worker-field">
          <span class="worker-field-label">Location ID</span>
          <code>{{ valueOrDash(paymentProvider?.locationId) }}</code>
        </div>
        <div class="worker-field">
          <span class="worker-field-label">Tag</span>
          <code>{{ valueOrDash(paymentProvider?.tag) }}</code>
        </div>
        <div class="worker-field">
          <span class="worker-field-label">Intentos</span>
          <span>{{ valueOrDash(paymentProvider?.currentAttempts) }}/{{ valueOrDash(paymentProvider?.maxAttempts) }}</span>
        </div>
        <div class="worker-field">
          <span class="worker-field-label">Versión</span>
          <span>{{ valueOrDash(paymentProvider?.version) }}</span>
        </div>
      </div>
    </mat-card>

    <mat-card class="worker-card">
      <h4>Planificación</h4>
      <div class="worker-fields">
        <div class="worker-field">
          <span class="worker-field-label">Periodicidad</span>
          <span>{{ paymentProvider?.periodic ? 'Sí' : 'No' }}</span>
        </div>
        <div class="worker-field">
          <span class="worker-field-label">Intervalo</span>
          <span>{{ formatSeconds(paymentProvider?.periodicIntervalSeconds) }}</span>
        </div>
        <div class="worker-field">
          <span class="worker-field-label">Próxima ejecución</span>
          <span>{{ formatDateTime(paymentProvider?.nextRun) }}</span>
        </div>
        <div class="worker-field">
          <span class="worker-field-label">Creado</span>
          <span>{{ formatDateTime(paymentProvider?.createdAt) }}</span>
        </div>
        <div class="worker-field full-span">
          <span class="worker-field-label">Actualizado</span>
          <span>{{ formatDateTime(paymentProvider?.updatedAt) }}</span>
        </div>
      </div>
    </mat-card>

    <mat-card class="worker-card">
      <h4>Restricciones</h4>
      <div class="worker-list">
        <div class="worker-list-item">
          <span>Requiere red</span>
          <strong>{{ boolLabel(paymentProvider?.requireNetwork) }}</strong>
        </div>
        <div class="worker-list-item">
          <span>Requiere CPU baja</span>
          <strong>{{ boolLabel(paymentProvider?.requireLowCpu) }}</strong>
        </div>
        <div class="worker-list-item">
          <span>Requiere idle</span>
          <strong>{{ boolLabel(paymentProvider?.requireIdle) }}</strong>
        </div>
        <div class="worker-list-item">
          <span>Actualmente reservado</span>
          <strong>{{ boolLabel(paymentProvider?.currentlyReserved) }}</strong>
        </div>
      </div>
    </mat-card>

    <mat-card class="worker-card worker-card--wide">
      <h4>Payload</h4>
      <pre class="worker-pre">{{ formatJson(paymentProvider?.payload) }}</pre>
    </mat-card>

    <mat-card class="worker-card worker-card--wide" *ngIf="paymentProvider?.lastError">
      <h4>Último error</h4>
      <pre class="worker-pre worker-pre--danger">{{ formatJson(paymentProvider?.lastError) }}</pre>
    </mat-card>
  </div>
</mat-dialog-content>
